const dateTimeConvert = (isoString: string): string => {
	const date = new Date(isoString)
	const offset = date.getTimezoneOffset() * 60000
	const local = new Date(date.getTime() - offset)
	return local.toISOString().slice(0, 16)
}

export default dateTimeConvert
